import { TField } from '$hook-forms/RecoveryCodeVerifyForm'
import { TypeSubmitForm } from '$hook-forms/types'

export type UseRecoveryCodeVerifyBlockOptions = TypeSubmitForm<TField> & {
  title: string
  description: string
  submitButtonText?: string
}

export const useRecoveryCodeVerifyBlock = (
  props: UseRecoveryCodeVerifyBlockOptions
) => props

export default useRecoveryCodeVerifyBlock
